/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/supplier-menu/shop.supplier-menu.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {Warenkorb} from '../../../../models/warenkorb';
import {AppDialogsService} from '../../../../services/app.dialogs.service';
import {MatDialog} from '@angular/material/dialog';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Artikel} from '../../../../models/artikel';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppSupplierService} from '../../../../services/app.supplier.service';
import {Supplier} from '../../../../models/supplier';

/**
 * Zweck: Beschreibt class ShopSupplierMenuComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.supplier-menu.component.html',
    styleUrls: ['shop.supplier-menu.component.scss'],
    standalone: false
})
export class ShopSupplierMenuComponent {
  static id = 'ShopSupplierMenuComponent';

  add_mode = false;

  newwk: Warenkorb;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public ssvc: AppSupplierService,
              private dsvc: AppDialogsService, private mdsvc: MatDialog,
              @Inject(MAT_BOTTOM_SHEET_DATA) public data: { artikel: Artikel, entry: WarenkorbEntry },
              private _bottomSheetRef: MatBottomSheetRef<ShopSupplierMenuComponent>) {
  }

/**
 * Beschreibt Methode cancel und ihren Rückgabevertrag.
 */
  cancel() {
    this.add_mode = false;
    this.newwk = undefined;
  }

/**
 * Beschreibt Methode add und ihren Rückgabevertrag.
 */
  add() {
    this.newwk = new Warenkorb();
    this.newwk.label = 'Neuer Warenkorb';
    this.newwk.shared = true;
    this.add_mode = true;
  }

/**
 * Beschreibt Methode selectSuppier und ihren Rückgabevertrag.
 */
  selectSuppier(s: Supplier) {
    this._bottomSheetRef.dismiss(s);
  }
}
